/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { run  } from './STLLoader';

window.addEventListener('WebComponentsReady', async () => {
  run(document.getElementById('viewer'));
  document.getElementById('gui').style.display = 'block';
});
